import api from "app/api";


export interface ChangeEmailRequestFormItem {
  email: string;
  password: string;
}

export function changeEmailRequest(item: ChangeEmailRequestFormItem) {
  return api.post(
    `/user/email-change-request`,
    {
      EmailActivationForm: item
    }
  );
}

export function changeEmail(token: string) {
  return api.post(
    `/identity/email-change?token=${token}`,
    {}
  );
}